import { useEffect, useRef, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { todayInWorkspaceTz } from "@/hooks/useWorkspaceTasks";

const STALE_MS = 60_000;

export function usePendingTasksCount(workspaceId: string | null, memberId: string | null) {
  const [count, setCount] = useState(0);
  const lastFetchAtRef = useRef(0);

  useEffect(() => {
    if (!workspaceId || !memberId) {
      setCount(0);
      return;
    }

    const fetchCount = async () => {
      lastFetchAtRef.current = Date.now();
      // Conta tarefas-raiz e subtarefas pendentes do membro com prazo até hoje.
      const { count: c, error } = await supabase
        .from("workspace_tasks")
        .select("id", { count: "exact", head: true })
        .eq("workspace_id", workspaceId)
        .eq("assigned_member_id", memberId)
        .eq("status", "pending")
        .lte("due_date", todayInWorkspaceTz());

      if (!error) setCount(c ?? 0);
    };

    void fetchCount();

    const onTasksChanged = () => {
      if (Date.now() - lastFetchAtRef.current < 1000) return;
      void fetchCount();
    };
    window.addEventListener("fabchat-tasks-changed", onTasksChanged);

    const interval = setInterval(() => {
      if (document.visibilityState === "visible" && Date.now() - lastFetchAtRef.current >= STALE_MS) {
        void fetchCount();
      }
    }, STALE_MS);

    return () => {
      window.removeEventListener("fabchat-tasks-changed", onTasksChanged);
      clearInterval(interval);
    };
  }, [workspaceId, memberId]);

  return count;
}

export function notifyTasksChanged() {
  window.dispatchEvent(new CustomEvent("fabchat-tasks-changed"));
}
